/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  "window",
  "react",
  "react-dom",
  "pip-model",
  "thd-overlay",
  "cookie-utils",
  "mustache",
  "jquery",
  "pip-ratings-reviews"
], function(
  window,
  React,
  ReactDOM,
  pip,
  thdOverlay,
  cookieUtils,
  Mustache,
  $,
  pipRatingsReviews
) {
    var version = "2.27.6";
    var src =
      "/p/static/node_modules/@thd-olt-component/ratings-reviews/dist/v" +
      version +
      ".ratings-reviews.umd.js";

    function getVersion() {
      return version;
    }

    function getSrc() {
      return src;
    }

    function setGlobalDependencies() {
      window.THD_OVERLAY = thdOverlay;
      window["cookieUtils"] = window["cookie-utils"] = cookieUtils;

      var eventBus = (window.THD_EVENT_BUS =
        (window.LIFE_CYCLE_EVENT_BUS &&
          LIFE_CYCLE_EVENT_BUS.LIFE_CYCLE_EVENT_BUS) ||
        getEventBusStub());

      eventBus.on("@@RATINGS-REVIEWS/EVENT", function(event) {
        if (window.digitalData && window.digitalData.event) {
          return digitalData.event.push(getRRThdAnalyticsEvent(event.output));
        }
      });
    }

    function getEventBusStub() {
      return {
        trigger: function(eventName, options) {
          if (eventName === "@@RATINGS-REVIEWS/EVENT") {
            if (window.digitalData && window.digitalData.event) {
              return digitalData.event.push(getRRThdAnalyticsEvent(options));
            }
          }
        },
        on: function() { }
      };
    }

    function getRRThdAnalyticsEvent(payload) {
      var origin = payload.origin;
      var location = payload.location;
      var value = payload.value;

      var componentName = "";
      var elementName = "";
      var moduleName = "";

      switch (location) {
        case "search": {
          componentName = "search reviews";
          elementName = "n/a";
          moduleName = origin;
          break;
        }
        case "filter": {
          componentName = "filter reviews";
          elementName = value || 'n/a';
          moduleName = origin;
          break;
        }
        case "writereview": {
          componentName = "write a review";
          elementName = "n/a";
          moduleName = origin;
          break;
        }
        case "keyword": {
          componentName = "keyword";
          elementName = value;
          moduleName = origin;
          break;
        }
        case "sort": {
          componentName = "sort by";
          elementName = value;
          moduleName = origin;
          break;
        }
        case "badge": {
          componentName = "badge";
          elementName = "n/a";
          moduleName = origin;
          break;
        }
        case "media": {
          componentName = "media";
          elementName = value;
          moduleName = origin;
          break;
        }
        case "readmore": {
          componentName = "read more";
          elementName = "n/a";
          moduleName = origin;
          break;
        }
        case "helpful": {
          componentName = "was this helpful";
          elementName = value;
          moduleName = origin;
          break;
        }
        case "profile": {
          componentName = "profile";
          elementName = "n/a";
          moduleName = origin;
          break;
        }
        case "pagination": {
          componentName = "pagination";
          elementName = "n/a";
          moduleName = origin;
          break;
        }
        case "starrating": {
          componentName = "star rating";
          elementName = "n/a";
          moduleName = origin;
          break;
        }
        case "sentiment": {
          componentName = value;
          elementName = "n/a";
          moduleName = origin;
          break;
        }
        default: {
          componentName = "search reviews";
          elementName = "n/a";
          moduleName = origin;
        }
      }

      return {
        category: {
          primaryCategory: "button submission"
        },
        eventInfo: {
          eventName: "ugc click"
        },
        content: {
          ugc: [
            {
              module: moduleName,
              component: componentName,
              element: elementName
            }
          ]
        }
      };
    }

    function initializeReact() {
      var props = getProps();
      if (pip.features.ugcZoneAReact && props.channel === "desktop") {
        ReactDOM.render(
          React.createElement(
            window["ratings-reviews"].ProductTitleDesktop,
            props,
            null
          ),
          document.getElementById("BVRRSummaryContainer"),
          zoneAOnRenderHandler
        );
      }

      ReactDOM.render(
        React.createElement(window["ratings-reviews"].default, props, null),
        document.getElementById("BVReactContainer")
      );
    }

    function zoneAOnRenderHandler() {
      pipRatingsReviews.init(true);
    }

    function loadScript() {
      var script = document.createElement("script");
      var firstScriptOnPage = document.getElementsByTagName("script")[0];
      script.type = "text/javascript";
      firstScriptOnPage.parentNode.insertBefore(script, firstScriptOnPage);
      script.onreadystatechange = initializeReact;
      script.onload = initializeReact;
      script.src = src;
    }

    function getProps() {
      return {
        channel: pip.platform.toLowerCase(),
        env: pip.env.toLowerCase(),
        apiKey: pip.bazaarVoiceFrontEndKey,
        itemId: pip.products.primary.data.itemId,
        skuInfo: fetchtskuInfo(),
        isProsAndConsEnabled: pip.features.ugcProsAndConsEnabled,
        showReviewsOnMobile: pip.features.reviewsOnMobilePageLoadEnabled
      };
    }

    function fetchtskuInfo() {
      return {
        productId: pip.products.primary.data.itemId,
        productBrand: pip.products.primary.data.info.brandName,
        name: pip.products.primary.data.info.productLabel,
        imageURL: getImageURL(),
        canonicalUrl: pip.products.primary.data.canonicalURL
      };
    }

    function getImageURL() {
      var mediaList = pip.products.primary.data.media.mediaList;
      var desiredResolution = "400";
      var imageArray = mediaList.filter(function(media) {
        return media.height === desiredResolution;
      });

      return imageArray[0] ? imageArray[0].location : "";
    }

    function setStars() {
      var zeroReviews =
        '<div class="mobile-star-ratings"><a href="#customer_reviews">(0) <div class="reviews"> <span class="stars" rel=0 style="width: 0%;">0</span></div></a></div>';
      var markup = Mustache.render(zeroReviews, {});
      $(".product-title__review-snippet, .mobile-star-ratings").replaceWith(
        markup
      );

      var numberOfTries = 0;
      var checkExist = setInterval(function() {
        if ($(".review-rating__mobile__rating").length) {
          var template =
            '<div class="mobile-star-ratings"><a href="#customer_reviews">{{{reviewCount}}} <div class="reviews"> <span class="stars" rel={{stars}} style="width: {{percentage}}%;">({{reviewCount}})</span></div></a></div>';
          var markup = Mustache.render(template, {
            stars: $(".review-rating__mobile__rating").html(),
            reviewCount: $(".review-rating__mobile__reviews").text(),
            percentage: ($(".review-rating__mobile__rating").html() / 5) * 100
          });
          $(".product-title__review-snippet, .mobile-star-ratings").replaceWith(
            markup
          );
          clearInterval(checkExist);
        }

        if (numberOfTries === 20) {
          clearInterval(checkExist); //Clear the timer after 10 sec.
        } else {
          numberOfTries++;
        }
      }, 500);
    }

    return {
      init: function() {
        if (pip.features.bazzarVoiceReactComponentEnabled) {
          setGlobalDependencies();
          loadScript();
          if (pip.platform === "MOBILE") {
            setStars();
          }
        }
      },
      fetchtskuInfo: fetchtskuInfo,
      getRRThdAnalyticsEvent: getRRThdAnalyticsEvent,
      getVersion: getVersion,
      getSrc: getSrc
    };
  });

}.call(window));